import type {Table} from 'dexie';
import Dexie from 'dexie';
import type {
  OfflineFile,
  OfflineSession,
  OfflineSnapshot,
  OutboxItem,
} from './types';

/**
 * IndexedDB (Dexie) database backing the offline session core: sessions,
 * write outbox, hydration snapshots, and captured/cached file blobs.
 */
class ProactOfflineDatabase extends Dexie {
  sessions!: Table<OfflineSession, string>;
  outbox!: Table<OutboxItem, string>;
  snapshots!: Table<OfflineSnapshot, [string, string]>;
  files!: Table<OfflineFile, string>;

  constructor() {
    super('proact-offline');

    this.version(1).stores({
      sessions: 'id, status',
      outbox: 'id, sessionId, [sessionId+seq], status',
      snapshots: 'key, sessionId',
    });

    this.version(2)
      .stores({
        snapshots: '[sessionId+key], sessionId, key',
      })
      .upgrade(tx => tx.table('snapshots').clear());

    this.version(3)
      .stores({
        sessions: 'id, status, contextKey',
        files: 'id, sessionId, [sessionId+refKey]',
      })
      .upgrade(tx =>
        tx
          .table('sessions')
          .toCollection()
          .modify(session => {
            session.ready = true;
          })
      );
  }
}

export const offlineDb = new ProactOfflineDatabase();
